import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { getDatabase, ref, child, get } from "firebase/database";
import AppConfig from "../service/firebase";

const HandleRedirectContainer = () => {
  const [destination, setDestination] = useState();
  const [error, setError] = useState();

  let { urlId } = useParams();

  useEffect(() => {
    async function getData() {
      const dbRef = ref(getDatabase(AppConfig));
      get(child(dbRef, `shortlink/${urlId}`))
        .then((snapshot) => {
          if (snapshot.exists()) {
            setDestination(snapshot.val().url);
          } else {
            console.log("No data available");
          }
        })
        .catch((error) => {
          setError(error);
          console.error(error);
        });
    }
    getData();
  }, [urlId]);

  useEffect(() => {
    if (destination) {
      window.location.replace(destination);
    }
  }, [destination]);

  if (!destination && !error) {
    return (
      <div className="spin">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return <p>{error && JSON.stringify(error)}</p>;
};

export default HandleRedirectContainer;
